/**
 * Trilingual text helper — returns the correct text for current i18n language.
 * Covers en, fr, es. Falls back to English if Spanish is missing.
 * 
 * Usage: tLang(i18n.language, 'English', 'Français', 'Español')
 */
export const tLang = (lang, en, fr, es) => {
  if (lang === 'fr') return fr || en;
  if (lang === 'es') return es || en;
  return en;
};
